import dayjs from "dayjs";

/** convert time such as like 2023-07-27T01:47:25.319Z to 2023-08-02 16:46:43 */
export const convertTime = (time: string): string => {
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};
